import { reduceReducers } from '../../../common/utils/reducer-utils';

import loading from './loading';

export default reduceReducers(
  loading,
);
